// extracted by mini-css-extract-plugin
export default {"tr":"AnchorTableRow_tr__v4-3A","arabic":"AnchorTableRow_arabic__iiGcR"};